import EdDialog from "./src/EdDialog.vue";

/* istanbul ignore next */
EdDialog.install = function (Vue) {
  Vue.component(EdDialog.name, EdDialog)
}

export default EdDialog
